import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProject,
  BackendQueryGetPerformanceCenterResultDocumentArgs,
} from 'src/types/backend';

const QUERY = gql`
  query GetPerformanceCenterResultDocument(
    $performanceCenterTextVariationsResultId: ID!
    $customerId: ID!
  ) {
    getPerformanceCenterResultDocument(
      performanceCenterTextVariationsResultId: $performanceCenterTextVariationsResultId
      customerId: $customerId
    ) {
      id
    }
  }
`;

type Variables = BackendQueryGetPerformanceCenterResultDocumentArgs;

export const getPerformanceCenterResultDocument = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Pick<BackendProject, 'id'>>(result.data)?.id;
};
